
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-dialog-document-viewer',
  templateUrl: './dialog-document-viewer.component.html',
  styleUrls: ['./dialog-document-viewer.component.css']
})
export class DialogDocumentViewerComponent implements OnInit {

  safeURL;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public sanitizer: DomSanitizer
  ) {
    const { file_path } = this.data;
    if (file_path) {
      this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(file_path);
    }
  }

  ngOnInit(): void {
  }

}
